import {
  Box,
  Stack,
  Typography
} from "@mui/material";
import { Divider } from "@mui/material";

const backgroundColor = "#202248";

function Logo() {
  // image from src/images/dashboard/logo_thei.png
  return (
    <Box
      component="img"
      src={require("../../../images/dashboard/logo_thei.png")}
      alt="logo"
      sx={{ height: 60, objectFit: "contain" }}
    />
  );
}

function BrightFutureLogo() {
  return (
    <Box
      component="img"
      src="/assets/logos/bright-future-logo-color.png"
      alt="logo"
      sx={{ height: 60, objectFit: "contain" }}
    />
  );
}

function IDSSMCLogo() {
  const fontColor = "#4be1fc";
  return (
    <Stack sx={{ ml: "auto" }}

      direction="column" alignItems="right" textAlign="right" spacing={1}>
      <Typography sx={{ fontSize: 20, color: fontColor, fontWeight: "bold" }}>
        Integrated Digital Science Sports Management Centre (IDSSMC)

      </Typography>

      <Typography sx={{ fontSize: 18, color: fontColor }}>
        AI in Sport Platform
      </Typography>
    </Stack>
  )
}

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        height: 80,
        display: "flex",
        alignItems: "center",
        backgroundColor: backgroundColor,
        px: 4,
      }}
    >
      <Stack direction="row" alignItems="left" spacing={4}>
        <Logo />
        <BrightFutureLogo />
      </Stack>
      
      {/* <Divider orientation="vertical" flexItem /> */}
      <IDSSMCLogo />
    </Box>
  );
}
